import React from 'react';
import {
  PieChart, Pie, Cell, ResponsiveContainer, Label,
} from 'recharts';

import './styles.css';

function CustomLabel({viewBox, value1, value2, fill}){
  const {cx, cy} = viewBox;
  return (
    <text x={cx} y={cy} fill={fill} className="recharts-text recharts-label" textAnchor="middle" dominantBaseline="central">
      <tspan alignmentBaseline="middle" dy={-6} fontSize="48">{value1}</tspan>
      <tspan fontSize="18" x={cx} fill={'#9B9B9B'} dy="30">{value2}</tspan>
    </text>
  );
}

class IssuedInvoicesOnTerminalChart extends React.Component {
  render() {
    const {
      forToday,
      onTime,
      lateOneDay,
      lateTwoDays,
      lateThreeDays,
    } = this.props;

    const data = [
      { name: 'onTime', value: onTime },
      { name: 'lateOneDay', value: lateOneDay },
      { name: 'lateTwoDays', value: lateTwoDays },
      { name: 'lateThreeDays', value: lateThreeDays },
    ];
    const COLORS = ['#21C756', '#F5A623', '#50E3C2', '#4A90E2'];

    return (
      <ResponsiveContainer width="50%" height='100%'>
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie
            data={data}
            innerRadius={120}
            outerRadius={130}
            fill="#8884d8"
            paddingAngle={5}
            dataKey="value"
            label={'teste'}
          >
            {
              data.map((entry, index) => <Cell cornerRadius={5} stroke={'#171717'} key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
            }
            <Label width={30} position="center"
                   content={<CustomLabel fill={'#ffffff'} value1={forToday} value2={'NFs pra hoje'}/>}>
            </Label>
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default IssuedInvoicesOnTerminalChart;
